import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import type { OptionProps } from 'react-select';

import URLRenderer from '../CellRenderers/URLRenderer';
type OptionLayoutLandingUrlsOption = {
  label: string;
  value?: string;
};

type OptionLayoutLandingUrlsProps = OptionProps<
  OptionLayoutLandingUrlsOption,
  false
>;

const OptionLayoutLandingUrls = (props: OptionLayoutLandingUrlsProps) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
            .customized-searchbox-option:hover{
              background-color:var(--falcon-gray-link-hover-300) !important;
            }
            .customized-searchbox-option{
              background-color:var(--falcon-tertiary-bg) !important;
            }
            `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className={classNames(
          'p-2 cursor-pointer border border-1 customized-searchbox-option',
          {}
        )}
      >
        <div className="fs--1 d-flex text-900">
          {!props.data.value && (
            <FontAwesomeIcon
              className="fs-0 d-inline-block me-2"
              icon={faGoogle}
            />
          )}
          <URLRenderer className="overflow-hidden" url={props.data.label} />
        </div>
      </div>
    </>
  );
};

export default OptionLayoutLandingUrls;
